import styled from "styled-components";

interface StyleProps {
  $isVisible: boolean;
}

export const DivCombinedProductModal = styled.div<StyleProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 5;

  @media (max-width: 1225px) {
    z-index: 9999;
  }

  & {
    .akn-combined-modal {
      &__title {
        font-weight: bold;
        margin-bottom: 25px;
        margin-top: 10px;
        color: #333333;
        display: flex;
        gap: 0.5ch;
      }
      &__count {
        font-weight: 400;
      }
      &__close {
        position: absolute;
        right: 25px;
        top: 20px;
        &:hover {
          cursor: pointer;
        }
        @media (max-width: 1225px) {
          background: #000;
          color: #fff;
          right: 0;
          top: 0;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 5px; /* to center*/
        }
      }
      &__products {
        display: flex;
        gap: 15px;
        @media (max-width: 1225px) {
          flex-wrap: wrap;
          gap: 10px;
          & > div {
            width: calc(50% - 5px);
            max-width: calc(50% - 5px);
          }
        }
      }
      &__content {
        background: #fff;
        padding: 15px;
        border-radius: 15px;
        position: relative;
        @media (max-width: 1225px) {
          height: 100%;
          width: 100%;
          padding: 15px;
          margin-top: 15px;
          overflow: auto;
          padding-bottom: 10rem;
        }
      }
    }
  }

  ${({ $isVisible }) => !$isVisible && `display:none;`}
`;
